export enum CreditorStatusTypes {
  ALL = "All",
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}
